module.exports = __webpack_public_path__ + "img/10-2.ce46c145.png";